export const BULK_UPLOAD_AUDIT_STORAGE_KEY =
  "publication_versions_bulk_upload_audit";

const MAX_AUDIT_ENTRIES = 20;

export function readBulkUploadAuditEntries() {
  try {
    const raw = sessionStorage.getItem(BULK_UPLOAD_AUDIT_STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function appendBulkUploadAuditEntry(entry) {
  const next = [entry, ...readBulkUploadAuditEntries()].slice(0, MAX_AUDIT_ENTRIES);
  try {
    sessionStorage.setItem(BULK_UPLOAD_AUDIT_STORAGE_KEY, JSON.stringify(next));
  } catch {
    /* ignore quota */
  }
  return next;
}

/** Cleared on logout so recent imports are not shown after the session ends. */
export function clearBulkUploadAuditStorage() {
  try {
    sessionStorage.removeItem(BULK_UPLOAD_AUDIT_STORAGE_KEY);
  } catch {
    /* ignore */
  }
}
